import React from 'react';
import { PictoProps } from './index';

export const CaretLeft = (props: PictoProps) => (
  <svg
    width={props.width || '9'}
    height={props.height || '14'}
    viewBox="0 0 9 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.44434 13L1.44434 7L7.44434 1"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
